export const sidebarData = [
  {
    title: "Complaints",
    path: "/admin/home",
    icon: "🧾",
    cName: "nav-text",
  },
  {
    title: "Your Profile",
    path: "/admin/profile",
    icon: "🧔🏻",
    cName: "nav-text",
  },
  {
    title: "Analytics",
    path: "/admin/analytics",
    icon: "📈",
    cName: "nav-text",
  },
  {
    title: "Add new Officer",
    path: "/admin/addOfficer",
    icon: "👮🏻‍♂️",
    cName: "nav-text",
  },
  
];
